// extracted by mini-css-extract-plugin
module.exports = {"button":"_1FCssP6rL7_calculator","extraClickZone":"_1YgCdvadZh_calculator"};